// import React from 'react';
// import Facts from '../components/vidarbha/hero'; 
// import Infrastructure from '../components/vidarbha/Infrastructure';
// import Properties6 from '../components/vidarbha/Properties6';
// import './VidarbhaPage.css';

// const VidarbhaPage = () => {
//     return (
//         <div className="page-container">
// <div className="popular-property-types">
//     <Facts />
// </div>
//             <div className="map-and-property-listing">
//                 {/* <div className="map">
//                     <Infrastructure />
//                 </div> */}
//                 <div className="property-listing">
//                     <Properties6 />
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default VidarbhaPage;








import React from "react";
import { Link } from "react-router-dom";
import {
    FaIndustry,
    FaMapMarkedAlt,
    FaChartLine,
    FaGlobeAsia,
    FaBuilding,
    FaTrain,
    FaRoute,
    FaSeedling,
} from "react-icons/fa";
import VidarbhaIndustrialDistrictMap from "../components/pages/VidarbhaIndustrialDistrictMap";
import Facts from "../components/vidarbha/hero";

const VidarbhaPage = () => {
    const stats = [
        {
            number: "11",
            label: "Districts",
            icon: <FaMapMarkedAlt className="w-8 h-8" />,
        },
        {
            number: "3.5M+",
            label: "Population",
            icon: <FaChartLine className="w-8 h-8" />,
        },
        {
            number: "97,321",
            label: "Area (sq km)",
            icon: <FaGlobeAsia className="w-8 h-8" />,
        },
        {
            number: "50+",
            label: "Major Industries",
            icon: <FaIndustry className="w-8 h-8" />,
        },
    ];

    const features = [
        {
            icon: "🌋",
            title: "Rich in Natural Resources",
            description:
                "Coal, limestone, iron ore and minerals make Vidarbha a base for raw material-centric industries.",
        },
        {
            icon: "🍊",
            title: "Agricultural Powerhouse",
            description:
                "World-famous oranges, cotton, soya & pulses, connecting agri-business & export clusters.",
        },
        {
            icon: "🏭",
            title: "Industrial Growth",
            description:
                "SEZs, industrial areas, EV manufacturing, textile zones & MSME industrial corridors.",
        },
        {
            icon: "🚄",
            title: "Connectivity Hub",
            description:
                "Rail, road & air connectivity strategically linking Central India to ports & metros.",
        },
    ];

    const amenities = [
        { name: "MIHAN SEZ", icon: <FaBuilding />, description: "Aviation, IT, logistics and pharma hub" },
        { name: "Nagpur Metro", icon: <FaTrain />, description: "Rapid urban public transport" },
        { name: "Samruddhi Mahamarg", icon: <FaRoute />, description: "Expressway linking Mumbai–Nagpur" },
        { name: "Agritech Clusters", icon: <FaSeedling />, description: "Cotton, oranges & food clusters" },
    ];

    return (
        <>


            <div className="popular-property-types">
                <Facts />
            </div>
            <div className="bg-gray-50 text-gray-800 font-inter">

                <div>
                    <VidarbhaIndustrialDistrictMap />
                </div>

                {/* Quote */}
                <section className="py-10">
                    <div className="max-w-4xl mx-auto px-6">
                        <div className="bg-violet-50 p-10 rounded-2xl shadow text-center">
                            <p className="text-2xl text-gray-700 italic leading-relaxed">
                                “Vidarbha’s strategic geography, raw material base and logistics
                                backbone create a long-term advantage for manufacturing, mobility,
                                warehousing and agro-industries.”
                            </p>
                            <p className="mt-5 text-violet-700 font-semibold">
                                — Maharashtra Industrial Development Corporation
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default VidarbhaPage;